import { AuthenticationService } from './../services/authentication.service';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { RestCallsService } from '../rest-calls.service';

@Component({
  selector: 'product.modal.page',
  templateUrl: './product.modal.page.html',
  styleUrls: [],
})
export class ProductModalPage implements OnInit {
  modalTitle: string;
  customerPrice = 0;
  minCustomerPrice = 0;
  gstIncluded = false;
  maxDiscount = 0;
  showError = false;
  product = {
    id: '',
    company_id: '',
    asin: '',
    name: '',
    model_id: '',
    category: '',
    type: '',
    series_name: '',
    mrp: 0,
    dealer_price: 0,
    dealer_price1: 0,
    dealer_price2: 0,
    dealer_price3: 0,
    unit: '',
    tax: '',
    desc: '',
    images: '',
    specification: '',
    brochure_url: '',
    is_active: '',
    created: '',
    updated: '',
    customerPrice: 0,
    discount: 0,
    hidePrice: false,
    quantity: 1,
    gstIncluded: false,
    showMrp: true,
  };
  showDp = false;
  showDpSelection = false;
  validationsForm: FormGroup = new FormGroup({
    discount: new FormControl('', Validators.compose([
      Validators.required,

      Validators.min(0),

    ]))

  });
  types = [
    'Distributor', 'Dealer', 'Sub Dealer', 'Retailer'
  ];
  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    private service: AuthenticationService,
    private apiService: RestCallsService,
    private authService: AuthenticationService
  ) {
    this.service.getLoggedInUser().then((res: any) => {
      console.log(res);
      if (res.data.useDp == 1 || res.data.type == 1) {
        if (this.apiService.typeOfInvoice == 'order' && this.apiService.typeOfCustomer == 2)
          this.showDpSelection = true;
      }

    });
  }

  ngOnInit() {
    this.product = this.navParams.data.product;
    this.types = [];
    if (this.product.dealer_price != null) {
      this.types.push("Distributor(" + this.product.dealer_price + ")");
    }
    if (this.product.dealer_price1 != null) {
      this.types.push("Dealer(" + this.product.dealer_price1 + ")");
    }
    if (this.product.dealer_price2 != null) {
      this.types.push("Sub Dealer(" + this.product.dealer_price2 + ")");
    }
    if (this.product.dealer_price3 != null) {
      this.types.push("Retailer(" + this.product.dealer_price3 + ")");
    }
    this.customerPrice = this.product.customerPrice === 0 ? this.product.mrp : this.product.customerPrice;

    this.authService.getLoggedInUser().then((user: any) => {
      console.log("1");
      if (user !== null) {
        console.log("2");
        if (user.data !== null) {
          console.log("3");
          if (user.data.showDp === 1) {
            console.log("4");
            this.showDp = true;
            console.log(this.product);
          }
          this.maxDiscount = user.data.maxDiscount;
          console.log("maxDiscount");
          console.log(user.data.maxDiscount);
          this.minCustomerPrice = this.product.mrp * (0.9);
        }
      }
    });
  }

  onTypeChange(val) {
    switch (val) {
      case "Distributor(" + this.product.dealer_price + ")":
        this.customerPrice = this.product.dealer_price;
        break;
      case "Dealer(" + this.product.dealer_price1 + ")":
        this.customerPrice = this.product.dealer_price1;
        break;
      case "Sub Dealer(" + this.product.dealer_price2 + ")":
        this.customerPrice = this.product.dealer_price2;
        break;
      case "Retailer(" + this.product.dealer_price3 + ")":
        this.customerPrice = this.product.dealer_price3;
        break;
    }
    this.showError = false;
    const totalDiscount = this.product.mrp - this.customerPrice;
    this.product.discount = parseInt(Number((totalDiscount / this.product.mrp) * 100).toFixed(2), 0x00);
   
  }
  closeModal() {
    this.product.customerPrice = this.customerPrice;
    this.modalController.dismiss(this.product);
  }
  done() {
    this.product.customerPrice = this.customerPrice;
    this.modalController.dismiss(this.product);
  }
  onMrpChange(value) {
    this.customerPrice = value;
    const totalDiscount = this.product.mrp - value;
    this.product.discount = parseInt(Number((totalDiscount / this.product.mrp) * 100).toFixed(2), 0x00);
    if (this.customerPrice < (this.product.mrp * ((100 - this.maxDiscount) / 100)) || this.customerPrice > this.product.mrp) {
      this.showError = true;
    } else {
      this.showError = false;
    }
  }

  onDiscountChange(value) {
    if (value > 100) {
      value = 100;
    }
    this.customerPrice = Math.round(this.product.mrp * ((100 - value) / 100));
    this.product.discount = value;
    if (this.customerPrice < (this.product.mrp * ((100 - this.maxDiscount) / 100)) || this.customerPrice > this.product.mrp) {
      this.showError = true;
    } else {
      this.showError = false;
    }
  }

  arrayOne(n: number): any[] {
    return Array(n);
  }

  showMrpChange(event) {
    this.product.showMrp = event.detail.checked;
    console.log(event.detail.checked);
  }
  onQuantityChange(value) {
    console.log(value);
    if (value !== '') {
      this.product.quantity = parseInt(value, 0x00);
    }
  }
  back() {
    this.modalController.dismiss(null);
  }
}
